import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '../views/NotFound.vue'
import { getLead, pingLead, getToken, loadErrorPage } from './api.js'

/** Deprecated routes left as comment block to avoid their inclusion in the production build
 * Path: /crear-cuenta/:leadUID
 * Replaced by /:leadUID as the entrypoint to continue account registration, after lead creation.
 * Paths: /gracias, /informacion-legal, /nosotros, /
 * Routes that were part of the original app but are not needed anymore because of the
 * replacement of karonte-frontend as landing page for Leva.
 */
// const deprecatedRoutes = [
//   {
//     path: '/crear-cuenta/:leadUID',
//     name: 'Crear cuenta',
//     component: () => import(/* webpackChunkName: "crear" */ '../views/CreateAccount.vue'),
//     beforeEnter: async (to) => {
//       const { leadUID } = to.params
//       const { success, lead } = await getLead(leadUID)
//       if (!success) router.push(`/crear_cuenta/${leadUID}`)
//       if (lead.lead_status !== 'new') router.push(`/cuenta-creada/${leadUID}`)
//       const tracker = new URLSearchParams(lead.tracking).toString()
//       await getTracking(to, tracker)
//     }
//   },
//     {
//     path: '/gracias',
//     name: 'Gracias',
//     component: () => import(/* webpackChunkName: "gracias" */ '../views/ThankyouPage.vue')
//   },
//   {
//     path: '/informacion-legal',
//     name: 'Información Legal',
//     component: () => import(/* webpackChunkName: "legal" */ '../views/LegalInformation.vue')
//   },
//   {
//     path: '/nosotros',
//     name: 'Nosotros - Leva Invierte',
//     component: () => import(/* webpackChunkName: "nosotros" */ '../views/NosotrosPage.vue')
//   },
//   {
//     path: '/',
//     name: 'Bienvenido a Leva Invierte',
//     component: () => import(/* webpackChunkName: "home" */ '../views/HomePage.vue'),
//     beforeEnter: async (to) => {
//       await getTracking(to)
//     }
//   }
// ]

const loadLead = async (to) => {
  const { leadUID } = to.params
  const { success, lead } = await getLead(leadUID)
  if (success) {
    if (lead.lead_status !== 'new') router.push(`/cuenta-creada/${leadUID}`)
    const tracker = new URLSearchParams(lead.tracking).toString()
    await getTracking(to, tracker)
  } else {
    loadErrorPage()
    return false
  }
}

const routes = [
  {
    path: '/pagina-no-encontrada',
    name: 'Error 404: Página no encontrada',
    component: NotFound
  },
  {
    path: '/cuenta-creada/:leadUID',
    name: 'Error: Cuenta Creada',
    component: () => import(/* webpackChunkName: "creada" */ '../views/AccountCreated.vue'),
    beforeEnter: async (to) => {
      const { leadUID } = to.params
      const { success, status } = await pingLead(leadUID)
      if (success && status === 'new') router.push(`/${leadUID}`)
      if (!success) {
        loadErrorPage()
        return false
      }
    }
  },
  {
    path: '/error',
    name: 'Error creando la cuenta',
    component: () => import(/* webpackChunkName: "error" */ '../views/SignupError.vue')
  },
  {
    path: '/inversion',
    name: 'Inversión - Leva Invierte',
    component: () => import(/* webpackChunkName: "inversion" */ '../views/InversionPage.vue'),
    beforeEnter: async (to) => {
      await getTracking(to)
    }
  },
  {
    path: '/calculadora',
    name: 'Calculadora',
    component: () => import(/* webpackChunkName: "calculadora" */ '../components/InvestmentCalculator.vue'),
    props: { standalone: true }
  },
  {
    path: '/productos',
    name: 'Productos',
    component: () => import(/* webpackChunkName: "productos" */ '../components/homePage/ourProducts.vue'),
    props: { standalone: true }
  },
  {
    path: '/crear-cuenta/:leadUID',
    name: 'Crear cuenta standalone',
    component: () => import(/* webpackChunkName: "account" */ '../views/CreateAccount.vue'),
    beforeEnter: loadLead,
    props: { standalone: true }
  },
  {
    path: '/:leadUID',
    name: 'Crear cuenta',
    component: () => import(/* webpackChunkName: "lead" */ '../views/CreateAccount.vue'),
    beforeEnter: loadLead
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: from => {
      sessionStorage.intentedUrl = from.fullPath
      return '/pagina-no-encontrada'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, _from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 100
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  }
})

const getTracking = async (to, artificial) => {
  const tracking = artificial ?? new URLSearchParams(to.query).toString()
  const { success, data } = await getToken(tracking)
  if (!success) return router.push('/pagina-no-encontrada')
  const { token } = data
  sessionStorage.appToken = token
}

router.beforeEach((to, _from, next) => {
  document.title = to.name
  next()
})

export default {
  install (app) {
    router.install(app)
    router.app = app
  }
}
